import React from "react";
import { motion } from "framer-motion";
import "./Reports.css";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const Background = () => {
  return (
    <motion.svg
      width="320"
      height="384"
      viewBox="0 0 320 384"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute inset-0 z-0"
      variants={{
        hover: {
          scale: 1.5,
        },
      }}
      transition={{
        duration: 1,
        ease: "backInOut",
      }}
    >
      <motion.circle
        variants={{
          hover: {
            scaleY: 0.5,
            y: -25,
          },
        }}
        transition={{
          duration: 1,
          ease: "backInOut",
          delay: 0.2,
        }}
        cx="160.5"
        cy="114.5"
        r="101.5"
        fill="#262626"
      />
      <motion.ellipse
        variants={{
          hover: {
            scaleY: 2.25,
            y: -25,
          },
        }}
        transition={{
          duration: 1,
          ease: "backInOut",
          delay: 0.2,
        }}
        cx="160.5"
        cy="265.5"
        rx="101.5"
        ry="43.5"
        fill="#262626"
      />
    </motion.svg>
  );
};

function Reports() {
  const navigate = useNavigate();
  return (
    <div className="d-flex flex-column container-fluid container-md gap-3">
      <h2>Reports</h2>
      <div className="grid grid-cols-3 gap-6 mt-2">
        <div className="mx-auto w-full">
          <motion.div
            whileHover="hover"
            transition={{
              duration: 1,
              ease: "backInOut",
            }}
            className="relative h-80 w-80 shrink-0 overflow-hidden rounded-xl bg-blueColor p-8"
          >
            <div className="relative z-10 text-white">
              <motion.span
                initial={{ scale: 0.85 }}
                transition={{
                  duration: 1,
                  ease: "backInOut",
                }}
                className="my-2 block origin-top-left font-mono text-4xl font-black leading-[1.2]"
              >
                Users
                <br />
                Report
              </motion.span>
            </div>

            <button
              className="absolute bottom-4 left-4 right-4 z-20 rounded border-2  bg-white py-2 text-center
               font-mono font-black uppercase text-neutral-800  "
              onClick={() => navigate("/app/UserReport")}
            >
              Get it now
            </button>

            <Background />
          </motion.div>
        </div>
        <div className="mx-auto w-full">
          <motion.div
            whileHover="hover"
            transition={{
              duration: 1,
              ease: "backInOut",
            }}
            className="relative h-80 w-80 shrink-0 overflow-hidden rounded-xl bg-yellowColor p-8"
          >
            <div className="relative z-10 text-white">
              <motion.span
                initial={{ scale: 0.85 }}
                transition={{
                  duration: 1,
                  ease: "backInOut",
                }}
                className="my-2 block origin-top-left font-mono text-4xl font-black leading-[1.2]"
              >
                Franchises
                <br />
                Report
              </motion.span>
            </div>
            <button
              className="absolute bottom-4 left-4 right-4 z-20 rounded border-2  bg-white py-2 text-center
               font-mono font-black uppercase text-neutral-800  "
              onClick={() => navigate("/app/FranchiseReport")}
            >
              Get it now
            </button>
            <Background />
          </motion.div>
        </div>
        <div className="mx-auto w-full">
          <motion.div
            whileHover="hover"
            transition={{
              duration: 1,
              ease: "backInOut",
            }}
            className="relative h-80 w-80 shrink-0 overflow-hidden rounded-xl bg-orangeColor p-8"
          >
            <div className="relative z-10 text-white">
              <motion.span
                initial={{ scale: 0.85 }}
                transition={{
                  duration: 1,
                  ease: "backInOut",
                }}
                className="my-2 block origin-top-left font-mono text-4xl font-black leading-[1.2]"
              >
                Cities
                <br />
                Report
              </motion.span>
            </div>
            <button
              className="absolute bottom-4 left-4 right-4 z-20 rounded border-2  bg-white py-2 text-center
               font-mono font-black uppercase text-neutral-800  "
              onClick={() => navigate("/app/CitiesReport")}
            >
              Get it now
            </button>
            <Background />
          </motion.div>
        </div>

      </div>
    </div>
  );
}

export default Reports;
